import { axios } from "./axiosSettings";
import { getAuthToken } from "../helpers/session.js";
import { logger } from "./logger";

export default class UserAgreement {
  static async CheckUserAgreement(userId) {
    try {
      const { data } = await axios.get(
        "/useragreement/check?userId=" + userId,
        {
          headers: {
            Authorization: `Bearer ${getAuthToken()}`,
          },
        }
      );
      return { isPolicyApproved: data.isPolicyApproved };
    } catch (e) {
      logger.error(e);
      return { error: e.message };
    }
  }

  static async SetUserAgreement(userId, agreementId, status) {
    try {
      const { data } = await axios.post(
        "/useragreement",
        {
          userId,
          agreementId,
          status,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getAuthToken()}`,
          },
        }
      );

      return { agreementData: data };
    } catch (e) {
      logger.error(e);
      return { error: e.message };
    }
  }
}
